import React from 'react'
import { Grid, Card, Divider, Box, Button, Stack, IconButton, useTheme, useMediaQuery, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import T from 'T'
import CSPricingListViewCell from 'components/configured-service/CreateDraftConfiguredServiceDialog/CSPricingListViewCell'
import { HHAlert } from 'components/common/HHAlert'
import { useCreateDraftConfiguredServiceContext } from '../CreateDraftConfiguredServiceContext'

const DraftServiceDetails = () => {
  const { selectedPricedService, handleClearSelection } = useCreateDraftConfiguredServiceContext()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <Grid
      container
      size={12}
      sx={{ pl: 2, py: 2, width: '100%', borderTop: 1, borderTopStyle: 'solid', borderTopColor: 'divider', bgcolor: 'background.default' }}
      columnGap={2}
    >
      {selectedPricedService ? (
        <>
          <Grid size="grow">
            <Stack sx={{ width: '100%', height: '100%' }} justifyContent="center" alignItems="center">
              <Card variant="outlined" sx={{ px: 1, width: '100%' }}>
                <CSPricingListViewCell row={selectedPricedService} />
              </Card>
            </Stack>
          </Grid>
          <Grid size="auto">{!isSmallScreen && <Divider orientation="vertical" variant="middle" />}</Grid>
          <Grid container size="auto" alignItems="center" justifyContent="center">
            {isSmallScreen ? (
              <Tooltip title={T.CLEAR_SELECTION} arrow>
                <IconButton color="error" onClick={handleClearSelection} size="small">
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Button variant="outlined" color="error" onClick={handleClearSelection}>
                {T.CLEAR_SELECTION}
              </Button>
            )}
          </Grid>
        </>
      ) : (
        <Box width="100%">
          <Stack sx={{ width: '100%', height: '100%' }} justifyContent="center" alignItems="center">
            <HHAlert severity="error">{T.NO_PRICED_SERVICE_SELECTED}</HHAlert>
          </Stack>
        </Box>
      )}
    </Grid>
  )
}

DraftServiceDetails.propTypes = {}

export default React.memo(DraftServiceDetails)
